import Flex, { GAP_CLASS } from "components/Flex";
import AddInSourceCard from "components/Modal/StartWritingProposalOutlineWizard/components/AddInSourceCard";
import VtSourceCard from "components/Modal/StartWritingProposalOutlineWizard/components/VtSourceCard";
import { DOC_SOURCE } from "constants/documents";
import { func, oneOf } from "prop-types";

const SourcePicker = ({ onChangeSource, source }) => {
  return (
    <>
      <p>
        You are about to combine all the sections into one doc. Choose where you
        want to store this doc.
      </p>

      <Flex alignItems="stretch" gap={GAP_CLASS.GAP_300}>
        <VtSourceCard
          isActive={source === DOC_SOURCE.VT_EDITOR}
          onClick={onChangeSource}
        />

        <AddInSourceCard
          isActive={source === DOC_SOURCE.ADDIN}
          onClick={onChangeSource}
        />
      </Flex>
    </>
  );
};

SourcePicker.propTypes = {
  onChangeSource: func.isRequired,
  source: oneOf(Object.values(DOC_SOURCE)),
};

export default SourcePicker;
